import React from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import ButtonWithIconCapitalize from '@/checkout-instore-legacy/components/ButtonWithIconCapitalize'

const FilterMobileBar = ({
  handleFilterButtonClick,
  selectedAttributes,
  disabled,
}: {
  handleFilterButtonClick: () => void
  selectedAttributes: { key: string; value: string }[]
  disabled: boolean
}) => (
  <div className="mv4 dn-ns db-s">
    <ButtonWithIconCapitalize
      testId="search-filters-mobile-open-button"
      size="small"
      variation="tertiary"
      noUpperCase
      disabled={disabled}
      icon={<Icon type="filters" height={16} width={16} />}
      onClick={handleFilterButtonClick}
    >
      <span className="f7">
        {selectedAttributes.length > 0 ? (
          <FormattedMessage
            id="filtersWithCount"
            values={{ count: selectedAttributes.length }}
          />
        ) : (
          <FormattedMessage id="filterSearch" />
        )}
      </span>
    </ButtonWithIconCapitalize>
  </div>
)

export default FilterMobileBar
